import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@material-ui/core';
import './BidProfileSelection.scss';
import {
    BidProfileStatus, EmployeeBiddingStatus, EmployeeBidProfileColumn, UkgDateFormat, BidProcessType,
} from '../../../Enums';
import { fetchEmployeeAppData } from '../../store/appData';
import DateFormatService from '../../../services/DateFormatService';
import BidsSection from './BidsSection';
import BidsSectionMobile from './BidsSectionMobile';

const widthMobileToggle = 993;
/**
 * @param {{search: string}} props
 */
function BidProfileSelection(props) {
    const dispatch = useDispatch();
    /** @type {ShiftBidding.EmployeeStore} */
    // @ts-ignore
    const { employeeAppData } = useSelector((state) => state);
    const {
        bidProfiles,
    } = employeeAppData;
    const [filteredProfiles, setFilteredProfiles] = useState(bidProfiles);
    const availableBidProfileStatus = [BidProfileStatus.Scheduled, BidProfileStatus.Active];
    const availableBidProfiles = filteredProfiles.filter((x) => availableBidProfileStatus.includes(x.status)
        && x.employeeSubmissionStatus === EmployeeBiddingStatus.Unsubmitted
        && !x.hasEmployeeSubmittedDraft);
    const inProgressBidProfiles = filteredProfiles.filter((x) => availableBidProfileStatus.includes(x.status)
        && x.employeeSubmissionStatus === EmployeeBiddingStatus.Unsubmitted
        && x.hasEmployeeSubmittedDraft);
    let isVisibleInProgressColumn = true;
    if (bidProfiles.every((x) => x.bidProcessType === BidProcessType.Sequential)) {
        isVisibleInProgressColumn = false;
    }

    const submittedBidProfiles = filteredProfiles.filter((x) => (availableBidProfileStatus.includes(x.status)
        && [EmployeeBiddingStatus.Submitted, EmployeeBiddingStatus.Declined].includes(x.employeeSubmissionStatus)));
    const closedBidProfiles = filteredProfiles.filter((x) =>
        [BidProfileStatus.Closed, BidProfileStatus.Published, BidProfileStatus.Canceled].includes(x.status));

    const { search } = props;
    useEffect(() => {
        dispatch(fetchEmployeeAppData());
    }, []);
    useEffect(() => {
        if (search) {
            const filtered = bidProfiles.filter((x) => {
                const searchString = `${x.name}|${DateFormatService.formatDateOrEmpty(x.submissionPeriodStartDate, UkgDateFormat.LongDate)}`.toLocaleLowerCase();
                return searchString.includes(search.toLocaleLowerCase());
            });
            setFilteredProfiles(filtered);
        } else {
            setFilteredProfiles(bidProfiles);
        }
    }, [JSON.stringify(bidProfiles), search]);

    const [windowWidth, setWindowWidth] = useState(0);
    useEffect(() => {
        function handleResize() {
            setWindowWidth(window.innerWidth);
        }
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => window.removeEventListener('resize', handleResize);
    }, []);
    const renderMatchingView = () => (
        windowWidth < widthMobileToggle
            ? (
                <div className="bid-profile-accordion-container">
                    <BidsSectionMobile
                        profiles={availableBidProfiles}
                        employeeBidProfileColumn={EmployeeBidProfileColumn.Available}
                    />
                    {isVisibleInProgressColumn && (
                        <BidsSectionMobile
                            profiles={inProgressBidProfiles}
                            employeeBidProfileColumn={EmployeeBidProfileColumn.Draft}
                        />
                    )}
                    <BidsSectionMobile
                        profiles={submittedBidProfiles}
                        employeeBidProfileColumn={EmployeeBidProfileColumn.Submitted}
                    />
                    <BidsSectionMobile
                        profiles={closedBidProfiles}
                        employeeBidProfileColumn={EmployeeBidProfileColumn.Closed}
                    />
                </div>
            ) : (
                <div className={isVisibleInProgressColumn ? 'bid-profile-desktop-4col-container' : 'bid-profile-desktop-3col-container'}>
                    <BidsSection
                        profiles={availableBidProfiles}
                        employeeBidProfileColumn={EmployeeBidProfileColumn.Available}
                    />
                    {isVisibleInProgressColumn && (
                        <BidsSection
                            profiles={inProgressBidProfiles}
                            employeeBidProfileColumn={EmployeeBidProfileColumn.Draft}
                        />
                    )}
                    <BidsSection
                        profiles={submittedBidProfiles}
                        employeeBidProfileColumn={EmployeeBidProfileColumn.Submitted}
                    />
                    <BidsSection
                        profiles={closedBidProfiles}
                        employeeBidProfileColumn={EmployeeBidProfileColumn.Closed}
                    />
                </div>
            )
    );
    return (
        <div className="employee-full-page">
            <Grid
                container
                classes={{ root: 'bid-dashboard-grid-container' }}
            >
                {renderMatchingView()}
            </Grid>
        </div>
    );
}
export default BidProfileSelection;
